module.exports = __FOREMAN_VENDOR__CORE_JS_SHIM__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__CORE_JS_SHIM__"
// module id = core-js/shim
// module chunks = 0